import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  ApiConfig
} from "./chunk-LPIRJEMY.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/events/listing.ts
import { getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var getEvents = (_0) => __async(void 0, [_0], function* ({
  lang,
  publicOnly,
  organizationSlug = "",
  seasonSlug = ""
}) {
  var _a, _b;
  try {
    const locale = getLocaleOnly(lang);
    const data = yield fetchClient({
      url: `/filter/events?lang=${locale}&organization_slug=${organizationSlug}&season_slug=${seasonSlug}&visible_in=${(_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.appSource}`,
      includeAuth: false
    });
    let events = data.data.data;
    let seasons = data.seasons;
    if (publicOnly) {
      events = data.data.data.filter((event) => event.visibility === "public");
      seasons = data.seasons.filter((season) => season.visibility === "public");
    } else {
      events = data.data.data.filter((event) => ["public", "private"].includes(event.visibility));
      seasons = data.seasons.filter((season) => ["public", "private"].includes(season.visibility));
    }
    return {
      events,
      seasons
    };
  } catch (error) {
    throw new Exception({ error, name: "getEventsException" });
  }
});
var eventsListByOrganizationSlug = (_0) => __async(void 0, [_0], function* ({ lang, page, perPage, slug }) {
  var _a, _b;
  try {
    const locale = getLocaleOnly(lang);
    const search = new URLSearchParams();
    search.append("lang", locale);
    search.append("visible_in", ((_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.appSource) || "");
    search.append("page", (page == null ? void 0 : page.toString()) || "0");
    search.append("per_page", (perPage == null ? void 0 : perPage.toString()) || "10");
    const base = `/organizations/${slug}/events`;
    const res = yield fetchClient({
      url: `${base}?${decodeURIComponent(search.toString())}`,
      includeAuth: false
    });
    return res.data;
  } catch (error) {
    throw new Exception({ error, name: "eventsListByOrganizationSlugException" });
  }
});

export {
  getEvents,
  eventsListByOrganizationSlug
};
//# sourceMappingURL=chunk-XLYMGK6X.mjs.map